import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Row, Col, Container, Button } from "reactstrap";
import classNames from "classnames";
import orangIcon from "../../../images/orang.png";
import {
  getCollectionPrefix,
  getCollectionNoCategory
} from "../../../actions/kafairAction";
import SneakerImage from "../../../components/Sneakers/SneakerImage";
import { TextRupiah } from "../../../components/Text";
import { getCloudImageUrl } from "../../../utils";
import Thumbnails from "../../PageProductDetails/Detail/Thumbnails";
import Countdown, { zeroPad } from "react-countdown";
import moment from "moment";
import bgImage from "../../../images/event_background.jpeg";

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return (
      <div>
        <span>
          {zeroPad(days)} : {zeroPad(hours)} : {zeroPad(minutes)} :{" "}
          {zeroPad(seconds)}
        </span>
      </div>
    );
  } else {
    return (
      <div className="countdown-wrapper green">
        <span>{zeroPad(days)}</span>
        <span>:</span>
        <span>{zeroPad(hours)}</span>
        <span>:</span>
        <span>{zeroPad(minutes)}</span>
        <span>:</span>
        <span>{zeroPad(seconds)}</span>
      </div>
    );
  }
};

class SurpriseDrop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      isFetching: false,
      availables: true,
      hasMoreData: false,
      currentIndex: 0
    };
  }

  componentDidMount() {
    this.getProductList();
  }

  goToProductList = () => {
    this.props.history.push("/kafair/surprise-drop");
  };

  getProductList = () => {
    const { page } = this.state;
    const payload = {
      prefix_slug: "surprise-drop",
      limited_time: true,
      page
    };

    const dataPayload = {
      prefix_slug: "surprise-drop",
      page,
      pre_verified: true
    };

    this.props
      .getCollectionPrefix(payload, "surprise_drop")
      .then(res => {
        const id = res.value.data ? res.value.data.data[0].id : null;

        this.props.getCollectionNoCategory(id, dataPayload, "surprise_drop");
      })
      .catch(e => {
        console.log(e);
      });
  };

  _renderItems(data) {
    const { dataList } = this.props.surpriseDrop;

    const startsAt =
      dataList.length > 0 && dataList[0].starts_at
        ? dataList[0].starts_at
        : null;

    const isStartSurprise = moment().isAfter(startsAt);

    return data.map((item, index) => (
      <a
        href={`/${item.category}/${item.id}/${item.slug}`}
        title={item.displayName}
        key={index}
        className="sneaker-item"
        style={
          !item.price || item.out_of_stock || !isStartSurprise
            ? {
                pointerEvents: "none"
              }
            : {}
        }
      >
        <div
          className={classNames("product-card", {
            disabled: item.disabled || !isStartSurprise
          })}
        >
          <div
            className={classNames("sneaker-item__text", {
              disabled: !item.price || item.out_of_stock || !isStartSurprise
            })}
          >
            <p>{item.brandName}</p>
            <p>{item.displayName}</p>
          </div>
          <KickImage
            hasImage={item.hasImage}
            src={item.src}
            alt={item.displayName}
            className={classNames("sneaker-item__image", {
              disabled: !item.price || item.out_of_stock || !isStartSurprise
            })}
          />
          {item.price ? (
            <div>
              <TextRupiah
                value={item.price}
                className="price-tag"
                color="black"
                bold={true}
                align="center"
              />
            </div>
          ) : (
            <span className="text-center">X</span>
          )}
        </div>
      </a>
    ));
  }

  renderProducts = () => {
    const {
      dataList,
      products: { data }
    } = this.props.surpriseDrop;

    const startsAt =
      dataList.length > 0 && dataList[0].starts_at
        ? dataList[0].starts_at
        : null;

    const isStartSurprise = moment().isAfter(startsAt);
    const previewSettings = {
      arrows: true,
      // autoplay:true,
      infinite: true,
      speed: 500,
      slidesToShow: data.length > 3 ? 3 : data.length,
      slidesToScroll: 3,
      lazyLoad: true,
      dots: false,
      swipe: false,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    return (
      <div>
        {data.length > 0 ? (
          <Thumbnails
            settings={previewSettings}
            beforeChange={this._handleBeforeChange}
            thumbnails={data.map(item => {
              return {
                disabled: !item.price || item.out_of_stock,
                brandName: item.product.brand.title
                  ? item.product.brand.title
                  : item.product.brand.name,
                displayName: item.display_name,
                hasImage: item.product_variant_images.length > 0 ? true : false,
                src: item.product_variant_images.length
                  ? getCloudImageUrl(item.product_variant_images[0].URL, 400)
                  : null,
                price: item.price,
                category: item.product.category.name,
                id: item.id,
                slug: item.slug
              };
            })}
            active={this.state.currentIndex}
            renderItems={data => this._renderItems(data)}
          />
        ) : null}
      </div>
    );
  };

  render() {
    const { dataList } = this.props.surpriseDrop;
    const imageBg =
      dataList.length > 0 &&
      dataList[0].categories &&
      dataList[0].categories.length > 0
        ? dataList[0].categories.find(c => c.name === "kafair")
        : null;
    const imageUrl = imageBg
      ? imageBg.pivot.images.length > 0 &&
        imageBg.pivot.images.find(i => i.orientation === "landscape")
      : null;

    const startsAt =
      dataList.length > 0 && dataList[0].starts_at
        ? dataList[0].starts_at
        : null;
    const expiry =
      dataList.length > 0 && dataList[0].expiry ? dataList[0].expiry : null;
    const isStart = moment().isAfter(startsAt);
    const isExpired = moment().isAfter(expiry);

    if (dataList.length === 0) return null;

    return (
      <Container fluid className="surprise-drop-container">
        <KickImage src={orangIcon} className="img-maskot" />
        {dataList.length > 0 ? (
          <KickImage src={imageUrl && imageUrl.URL} className="img-background" />
        ) : (
          <KickImage src={bgImage} className="img-background" />
        )}
        <Row className="content-container">
          <Col md={12} xs={12}>
            <div className="left-side">
              <Row>
                <Col>
                  <div
                    className="see-all d-none d-sm-block"
                    onClick={this.goToProductList}
                  >
                    <span>LIHAT SEMUA</span>
                  </div>
                </Col>
              </Row>
              <span className="title">SURPRISE DROP</span>
              <div className="countdown">
                {expiry ? (
                  <>
                    <div className="timer-wrapper">
                      <span>{isStart ? "BERAKHIR DALAM" : "MULAI DALAM"}</span>
                      <Countdown
                        date={
                          isStart
                            ? moment(expiry).toISOString()
                            : moment(startsAt).toISOString()
                        }
                        daysInHours={true}
                        zeroPadTime={2}
                        renderer={renderer}
                      />
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </Col>
          <Col md={12} xs={12}>
            <div className="right-side">
              {this.renderProducts()}
              <div
                className="see-all d-block d-sm-none"
                onClick={this.goToProductList}
              >
                <span>LIHAT SEMUA</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  surpriseDrop: state.dataKaFair.surprise_drop,
  data: state.dataKaFair
});

const mapDispatchToProps = dispatch => ({
  getCollectionPrefix: (payload, name) =>
    dispatch(getCollectionPrefix(payload, name)),
  getCollectionNoCategory: (id, payload, name) =>
    dispatch(getCollectionNoCategory(id, payload, name))
});

export default connect(mapStateToProps, mapDispatchToProps)(SurpriseDrop);
